import { render } from "./ErrorDialog.vue?vue&type=template&id=a32792ac&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"

import "./ErrorDialog.vue?vue&type=style&index=0&id=a32792ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32792ac"]])

export default __exports__